import type { CellStyle } from "ag-grid-community";
import {
	statusOf,
	TOLERANCE_STATUS,
	type InspectionValue,
} from "../models/Inspection";

interface SummaryMeasurementStyleParams {
	reading?: Pick<InspectionValue, "NumericValue" | "Ltl" | "Utl" | "Checked">;
	applies?: boolean;
	/** False when the sample has no specification: nothing is flagged. */
	evaluated?: boolean;
	errorColor: string;
	missingValueColor: string;
	notApplicableBackground: string;
}

export const getSummaryMeasurementStyle = ({
	reading,
	applies,
	evaluated = true,
	errorColor,
	missingValueColor,
	notApplicableBackground,
}: SummaryMeasurementStyleParams): CellStyle => {
	const status = statusOf(reading?.NumericValue, reading?.Ltl, reading?.Utl);
	// Go/No Go and Yes/No checks are judged without tolerances, so they always count.
	const error =
		reading?.Checked === false ||
		(evaluated &&
			(status === TOLERANCE_STATUS.OVER || status === TOLERANCE_STATUS.UNDER));
	const missing = reading?.NumericValue == null && reading?.Checked == null;
	// AG Grid retains old styles unless a refreshed cell explicitly resets them.
	return {
		textAlign: "center",
		color: error
			? errorColor
			: applies === true && missing
				? missingValueColor
				: "inherit",
		backgroundColor:
			applies === false ? notApplicableBackground : "transparent",
	};
};
